import Vue from 'vue'

export default {
  setItem (state, {item, resource}) {
    Vue.set(state[resource].items, item.id, item)
  },
  deleteItem (state, {itemId, resource}) {
    Vue.delete(state[resource].items, itemId)
  },
  setItemForm (state, {item, resource}) {
    Vue.set(state[resource].items[item.tipoFormulario], item.id, item)
  },
  deleteItemForm (state, {item, resource}) {
    Vue.delete(state[resource].items[item.tipoFormulario], item.id)
  },


    SET_RESUMO_INDICADOR(state, payload) {
      //state.items[payload.logicaIntervencaoId]['resumoIndicador'] = payload.resumoIndicador
      Vue.set(state['logicaIntervencao'].items[payload.logicaIntervencaoId]['resumoIndicador'], payload.resumoIndicador)
    },
    SET_RESUMO_ATIVIDADE(state, payload) {
      //state.items[payload.logicaIntervencaoId]['resumoAtividade'] = payload.resumoAtividade
      Vue.set(state['logicaIntervencao'].items[payload.logicaIntervencaoId]['resumoAtividade'], payload.resumoAtividade)
    },
    SET_PROGRESSO_LOGICA_INTERVENCAO(state, payload) {
      //state.items[payload.logicaIntervencaoId]['progressoLogicaIntervencao'] = payload.progressoLogicaIntervencao
      Vue.set(state['logicaIntervencao'].items[payload.logicaIntervencaoId]['progressoLogicaIntervencao'], payload.progressoLogicaIntervencao)
    },



}
